import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsWhichProducesResourceIdAvailable } from "./selectBuildingsWhichProducesResourceIdAvailable";
export var selectBuildingsProducingOrFinishedProductionResourceAvailable = function (state, resourceId) {
    var availableBuildings = selectBuildingsWhichProducesResourceIdAvailable(state, resourceId);
    return availableBuildings.filter(function (building) {
        return utilBuildings.hasResourceProduct(building, resourceId);
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/selectors/selectBuildingsProducingOrFinishedProductionResourceAvailable.ts
// module id = 256
// module chunks = 3